var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 41C38.0751 41 43 36.0751 43 30C43 23.9249 38.0751 19 32 19C25.9249 19 21 23.9249 21 30C21 36.0751 25.9249 41 32 41Z",
    fill: "#E0E5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6C26.8577 6 21.8309 7.52487 17.5552 10.3818C13.2795 13.2387 9.94702 17.2994 7.97914 22.0502C6.01127 26.8011 5.49638 32.0288 6.49959 37.0723C7.50281 42.1159 9.97907 46.7486 13.6152 50.3848C17.2514 54.0209 21.8842 56.4972 26.9277 57.5004C31.9712 58.5036 37.1989 57.9887 41.9498 56.0209C46.7007 54.053 50.7613 50.7205 53.6182 46.4448C56.4751 42.1691 58 37.1423 58 32C57.9868 25.1084 55.2433 18.5029 50.3702 13.6298C45.4971 8.75674 38.8916 6.01321 32 6ZM48.45 46.6C46.8311 44.2777 44.7448 42.3192 42.325 40.85C39.5466 43.5118 35.8477 44.9977 32 44.9977C28.1524 44.9977 24.4534 43.5118 21.675 40.85C19.2552 42.3192 17.169 44.2777 15.55 46.6C12.7345 43.4294 10.8951 39.5128 10.2534 35.3213C9.61169 31.1299 10.1949 26.8424 11.9329 22.9746C13.6709 19.1069 16.4895 15.8238 20.0497 13.5206C23.6098 11.2173 27.7597 9.99187 32 9.99187C36.2403 9.99187 40.3902 11.2173 43.9503 13.5206C47.5105 15.8238 50.3292 19.1069 52.0671 22.9746C53.8051 26.8424 54.3883 31.1299 53.7466 35.3213C53.1049 39.5128 51.2656 43.4294 48.45 46.6Z",
    fill: "#E0E5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.95c9b4105cc031d873ebb0b293eb7c7b.svg";
export { ForwardRef as ReactComponent };